<template lang="pug">
VBtn(
  variant="outlined"
  @click="shareClick"
)
  VIcon.mr-2(color="secondary") {{ mdiShareVariant }}
  | {{ i18n.t("Share.Share") }}
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { mdiShareVariant } from "@mdi/js";
import { Share } from "@capacitor/share";
import { useToastStore } from "~/stores/useToastStore";

const i18n = useI18n();
const toastStore = useToastStore();

interface Props {
  /**
   * The title to be shared along with the URL.
   */
  title: string;
}

const props = withDefaults(defineProps<Props>(), {});

async function shareClick() {
  if (!import.meta.client) {
    // This only works on the client.
    return;
  }

  const canShare = await Share.canShare();
  if (canShare.value) {
    return Share.share({
      text: props.title,
      url: window.location.href,
    });
  }

  if (navigator.clipboard) {
    await navigator.clipboard.writeText(window.location.href);
    toastStore.toast({
      text: i18n.t("Share.ShareCopiedClipboard"),
    });
    return;
  }

  toastStore.toast({
    text: i18n.t("Share.ShareCopyManually"),
  });
}
</script>
